// src/reducers/rootReducer.js
import { combineReducers } from 'redux';
import layout from './layout';
import cart from './cart';
import profile from './profile';
import config from './config';
import app from './app';
import paymentReducer from '../reducers/paymentRedu';

const rootReducer = combineReducers({
  layout,
  cart,
  profile,
  config,
  app,
  payment: paymentReducer,
});

export default rootReducer;
